import type { DocumentJournalEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const DocumentIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<path d="M9 2H4a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 4 14h8a1.5 1.5 0 0 0 1.5-1.5V6.5L9 2Z" />
		<path d="M9 2v4.5H13.5" />
		<path d="M5.5 9h5M5.5 11.5h3" />
	</svg>
)

export function DocumentEventRow({ event }: { event: DocumentJournalEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const copy =
		event.type === "document.created"
			? t.journal.events.documentCreated
			: event.type === "document.deleted"
				? t.journal.events.documentDeleted
				: t.journal.events.documentUpdated
	return (
		<JournalRowShell
			icon={<DocumentIcon />}
			headline={copy.label}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor })}
		/>
	)
}
